module.exports = __webpack_public_path__ + "static/media/xls.7be1227c.png";